import React from 'react';
import GlobalStyled from '../components/app/StyledApp';
import BoardingTicket from '../components/boardingTicket/BoardingTicket';


const TicketPurchase = () => {
  return (
    <>
    <GlobalStyled />        
    <BoardingTicket />
        </>
  );
};

export default TicketPurchase;